import { render, staticRenderFns } from "./quadanhan.vue?vue&type=template&id=06a80b02&scoped=true&"
import script from "./quadanhan.vue?vue&type=script&lang=js&"
export * from "./quadanhan.vue?vue&type=script&lang=js&"
import style0 from "./quadanhan.vue?vue&type=style&index=0&id=06a80b02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../usr/lib/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a80b02",
  null
  
)

export default component.exports